import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  AddIcon,
  CloseIcon,
  MicIcon,
  NotInLocationPicture,
  StopIcon
} from "../../Assets/assets";
import AudioPlayer from "../../Components/AudioPlayer/AudioPlayer";
import Button from "../../Components/Button/Button";
import CropperModal from "../../Components/CropperModal/CropperModal";
import Header from "../../Components/Header/Header";
import InputBox from "../../Components/InputBox/InputBox";
import Modal from "../../Components/Modal/Modal";
// import Select from "../../Components/Select/Select";
import NativeSelect from "../../Components/NativeSelect/NativeSelect";
import useVoiceRecorder from "../../CustomHooks/useVoiceRecorder";
import { createComplaint } from "../../Redux/complaints/action";
import { setErrorStatus } from "../../Redux/status/action";
import { voiceRecorderTimeLimit } from "../../Services/config";
import {
  isValidArray,
  isValidIndianPhoneNumber,
  isValidObject
} from "../../Services/validators";
import { ieComplaintCategories, locationRange } from "../../Utils/constants";
import "./RaiseComplaint.css";

function IeRaiseComplaint(props) {
  const [voiceRecorderControl, setVoiceRecorderControl] = useState(null);
  const { startRecording, saveRecording } = useVoiceRecorder();
  const [file, setFile] = useState({
    image: [],
    audio: null
  });
  const [croppedImage, setCroppedImage] = useState([]);
  const [running, setRunning] = useState(false);
  const [counter, setCounter] = useState(null);
  const [recordedAudio, setRecordedAudio] = useState({
    audioBlob: false,
    audioURL: ""
  });
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    if (recordedAudio?.audioURL) {
      setVoiceRecorderControl(null);
    }
  }, [recordedAudio?.audioURL]);

  useEffect(() => {
    props.requestLocationPermission();
    const selectedLocation = props.locations.selectedLocation;
    props.setFormData({
      ...props.formData,
      name: props.profile.data?.name,
      phoneNumber: props.profile.data?.phoneNumber,
      locationData: {
        key: selectedLocation,
        title: `${props.locations.data?.[selectedLocation]?.PCTNo} - ${props.locations.data?.[selectedLocation]?.location}`
      }
    });
    return () => {
      props.setFormData({
        name: props.formData.name,
        issue: [],
        locationData: {
          key: selectedLocation,
          title: `${props.locations.data?.[selectedLocation]?.PCTNo} - ${props.locations.data?.[selectedLocation]?.location}`
        },
        phoneNumber: props.formData.phoneNumber,
        turnaround: "",
        period: props.formData.period
      });
    };
    // eslint-disable-next-line
  }, [props.profile]);

  const voiceRecorderHandler = async () => {
    if (voiceRecorderControl === null || voiceRecorderControl === "cancel") {
      setVoiceRecorderControl("start");
      setCounter(0);
      setRunning(true);

      const res = await startRecording();
      if (res === false) {
        /**
         * voice recorder returns false is microphone is detected or any other issues in recording
         */
        setVoiceRecorderControl(null);
      }
    } else if (voiceRecorderControl === "start") {
      setVoiceRecorderControl("stop");
      setCounter(null);
      setRunning(false);
      const resBlob = await saveRecording();

      setRecordedAudio({
        audioBlob: resBlob,
        audioURL: URL.createObjectURL(resBlob)
      });

      const audioFile = new File([resBlob], `${+new Date()}.mp3`, {
        type: "audio/mp3"
      });

      setFile({
        ...file,
        audio: audioFile
      });
    } else if (voiceRecorderControl === "stop") {
      setVoiceRecorderControl("cancel");
      setRecordedAudio({
        audioBlob: false,
        audioURL: ""
      });
    }
  };

  useEffect(() => {
    let counterTimer;
    if (
      counter !== null &&
      typeof counter === "number" &&
      counter <= voiceRecorderTimeLimit &&
      running
    ) {
      counterTimer = setTimeout(() => {
        setCounter(counter + 1);
      }, 1000);
    } else {
      return () => clearTimeout(counterTimer);
    }
    if (counter === voiceRecorderTimeLimit) {
      setVoiceRecorderControl("stop");
      voiceRecorderHandler();
    }
    // eslint-disable-next-line
  }, [counter]);

  useEffect(() => {
    const { name, issue, locationData, phoneNumber, description } =
      props.formData;

    const isValid =
      isValidIndianPhoneNumber(phoneNumber) &&
      locationData?.title &&
      issue.length > 0 &&
      name.length > 0 &&
      description?.length > 0 &&
      (croppedImage.length > 0 || file.audio) &&
      !running;

    setIsDisabled(!isValid);
  }, [props.formData, file, croppedImage, running]);

  return (
    <div className="inherit-parent-width inherit-parent-height flex-center-children-horizontally">
      <div className="max-width-767px inherit-parent-width inherit-parent-height">
        <Header
          title="Customer Support"
          backOnClick={() => {
            props.navigate("/locationSearch");
            props.setFormData({
              name: "",
              issue: [],
              pctNo: "",
              phoneNumber: "+91",
              callId: ""
            });
          }}
          profileOnClick={props.profileOnClick}
        />

        <div className="padding-large parent-height-sub-64px">
          {isValidObject(props.locations.data) ? (
            props.locations.distance !== null &&
            props.locations.distance < locationRange &&
            !props.locations.loading ? (
              <form
                className="inherit-parent-height display-flex flex-direction-column flex-justify-content-space-between"
                onChange={(event) => {
                  if (event.target.name === "penaltyClause") {
                    props.setFormData({
                      ...props.formData,
                      issue: [event.target.value]
                    });
                  } else {
                    props.setFormData({
                      ...props.formData,
                      [event.target.name]: event.target.value
                    });
                  }
                }}
                onSubmit={(event) => {
                  event.preventDefault();
                  const data = {
                    name: props.formData.name,
                    issue: props.formData.issue,
                    description: props.formData.description,
                    locationId: props.formData.locationData.key,
                    phoneNumber: props.formData.phoneNumber,
                    sourceType: "Others",
                    employeeType: "independentEngineer",
                    mediaData: file.audio
                      ? [...croppedImage, file.audio]
                      : croppedImage
                    // turnaround: props.formData.issue.map((data) => ieComplaintCategories.find((category) => category.issue === data.title)?.timeLimit )
                  };
                  props.createComplaint(data, props.navigate, true);
                }}
              >
                <div>
                  <div className="font-size-medium text-align-center ">
                    RAISE COMPLAINT
                  </div>
                  <div className="margin-top-large">
                    <InputBox
                      name="PCT"
                      type="text"
                      removeResponsive={true}
                      label="PCT"
                      value={props.formData.locationData.title}
                      disabled={true}
                    />
                    <InputBox
                      name="name"
                      type="text"
                      removeResponsive={true}
                      label="NAME"
                      value={props.formData.name}
                      disabled={true}
                    />

                    <InputBox
                      className={`inherit-parent-width border-radius-default margin-top-default`}
                      name="phoneNumber"
                      label="Phone Number"
                      type="tel"
                      value={props.formData.phoneNumber}
                      removeResponsive={true}
                      disabled={true}
                    />

                    <InputBox
                      name="description"
                      type="text"
                      removeResponsive={true}
                      label="DESCRIPTION"
                      value={props.formData.description}
                      className={`margin-top-default`}
                      // disabled={true}
                    />

                    {/* <Select
                      chips={props.formData?.issue}
                      clearChips={() => {
                        props.setFormData({
                          ...props.formData,
                          issue: []
                        });
                      }}
                      modalTitle="SELECT PENALTY CLAUSE"
                      removeResponsive={true}
                      showAddOption={true}
                      // multiSelect={true}
                      name="category"
                      label="penalty clause"
                      onChipAdded={(data) => {
                        props.setFormData({
                          ...props.formData,
                          issue: data
                        });
                      }}
                      data-cy="category-chip-input-box"
                      options={ieComplaintCategories.map((title, index) => ({
                        title: `${index+1}. ${title}`,
                        key: title
                      }))}
                      sort = {false}
                    /> */}

                    <NativeSelect
                      name="penaltyClause"
                      removeResponsive={true}
                      label="PENALTY CLAUSE"
                      selectClassName="text-transform-capitalize"
                      options={[
                        "",
                        ...ieComplaintCategories?.map(
                          (title, index) => `${index + 1}. ${title}`
                        )
                      ]}
                      defaultValue={props.formData?.issue[0] || ""}
                      // fontColor={
                      //   props.theme === "dark"
                      //     ? "font-color-white"
                      //     : "font-color-secondary"
                      // }
                    />

                    {/* <div className=" display-flex flex-justify-content-space-between padding-top-large">
                        <InputBox
                          className="margin-right-default"
                          name="turnaround"
                          type="text"
                          removeResponsive={true}
                          label="TURNAROUND"
                          value={props.formData.turnaround}
                          size="half"
                          validation={(value) => {
                            if (
                              value.length > 0 &&
                              (isNaN(Number(value)) ||
                                Number(value) <= 0 ||
                                Number(value) >= 100)
                            ) {
                              return {
                                status: false,
                                message: "Please enter number only"
                              };
                            }
                          }}
                        />

                        <NativeSelect
                          className="margin-left-default"
                          name="period"
                          removeResponsive={true}
                          label="PERIOD"
                          selectClassName="text-transform-capitalize"
                          options={["", "Hours", "Days"]}
                          defaultValue={props.formData.period}
                          size="half"
                        />
                      </div> */}

                    <div className=" padding-top-large">
                      <>
                        <div className="padding-bottom-default font-family-RHD-regular">
                          Take Images
                        </div>
                        <div className="display-flex">
                          {croppedImage?.map((data, index) => (
                            <div
                              key={index}
                              style={{ height: "56px" }}
                              className="margin-right-large position-relative"
                              data-cy={`uploaded-image-thumbnail-${index}`}
                            >
                              <div
                                onClick={() => {
                                  setCroppedImage(
                                    Object.values(croppedImage).filter(
                                      (value) => value.name !== data.name
                                    )
                                  );
                                }}
                                data-cy="remove-uploaded-image-button"
                                className="background-color-grey width-fit-content border-radius-100-percentage flex-align-items-center flex-justify-content-center position-absolute right-0 opacity-60-percent"
                              >
                                <CloseIcon />
                              </div>
                              <img
                                className="border-radius-default"
                                height={56}
                                width={56}
                                src={data && URL.createObjectURL(data)}
                                alt="data"
                              />
                            </div>
                          ))}

                          <form
                            className="inherit-parent-width"
                            onChange={(event) => {
                              if (event.target.files) {
                                if (
                                  [
                                    "image/png",
                                    "image/jpeg",
                                    "image/jpg"
                                  ].includes(event.target.files[0]?.type) ===
                                  false
                                ) {
                                  return setErrorStatus({
                                    code: "custom",
                                    message: "Kindly upload a valid File"
                                  });
                                }

                                if (
                                  [
                                    "image/png",
                                    "image/jpeg",
                                    "image/jpg"
                                  ].includes(event.target.files[0]?.type) ===
                                  true
                                ) {
                                  setFile({
                                    image: [
                                      ...file.image,
                                      URL.createObjectURL(event.target.files[0])
                                    ]
                                  });
                                }
                              }
                            }}
                          >
                            <div className="height-width-56px margin-bottom-default cursor-pointer">
                              <label>
                                <input
                                  type="file"
                                  accept=".jpg,.jpeg,.png"
                                  name={
                                    props.inputName
                                      ? props.inputName
                                      : "fileUploaderInput"
                                  }
                                  onClick={(event) => {
                                    event.target.value = "";
                                  }}
                                  className="visibility-hidden position-absolute"
                                />

                                {(!isValidArray(croppedImage) ||
                                  (isValidArray(croppedImage) &&
                                    croppedImage.length <= 4)) && (
                                  <div
                                    className="background-color-secondary height-width-56px display-flex flex-justify-content-center flex-align-items-center border-radius-default padding-top"
                                    data-cy="file-upload-icon"
                                  >
                                    <AddIcon />
                                  </div>
                                )}
                              </label>
                            </div>
                          </form>
                        </div>
                      </>
                      <>
                        <div className="padding-top-small font-family-RHD-regular">
                          Add voice notes (Optional)
                        </div>

                        <div className="flex-justify-content-space-center margin-vertical-large flex-align-items-center">
                          {!recordedAudio?.audioURL && (
                            <div className="flex-justify-content-space-between inherit-parent-width flex-align-items-center">
                              <div className="display-flex flex-align-items-center">
                                <div
                                  className="flex-place-children-page-center  border-radius-50-percentage"
                                  onClick={() => voiceRecorderHandler()}
                                  data-cy={`${
                                    voiceRecorderControl === "start"
                                      ? "stop-record-button"
                                      : "start-record-button"
                                  }`}
                                >
                                  {voiceRecorderControl === "start" ? (
                                    <StopIcon />
                                  ) : (
                                    <MicIcon />
                                  )}
                                </div>
                                <div className="padding-left-large">
                                  {voiceRecorderControl === "start"
                                    ? "Recording..."
                                    : "Tap the mic to record audio"}
                                </div>
                              </div>
                              {voiceRecorderControl === "start" && (
                                <div style={{ width: 50 }}>
                                  00:
                                  {counter?.toString().length === 1 ? "0" : ""}
                                  {counter}
                                </div>
                              )}
                            </div>
                          )}
                          {recordedAudio?.audioURL && (
                            <AudioPlayer
                              className={"flex-basis-80-percentage"}
                              closeOnClick={() => {
                                setRecordedAudio({
                                  audioBlob: false,
                                  audioURL: ""
                                });
                                setFile({
                                  ...file,
                                  audio: null
                                });
                              }}
                              src={
                                typeof recordedAudio.audioURL === "string"
                                  ? recordedAudio.audioURL
                                  : ""
                              }
                            />
                          )}
                        </div>
                      </>
                    </div>
                  </div>
                </div>
                <div className="padding-top-default">
                  <div
                    style={
                      props.formData.phoneNumber.replace("+91", "")?.length ===
                        10 || props.formData.callId
                        ? { opacity: 1 }
                        : { opacity: 0.5 }
                    }
                    className="display-flex font-size-medium flex-justify-content-center"
                  >
                    Want to link with existing complaint?
                    <span
                      onClick={() => {
                        if (
                          props.formData.phoneNumber.replace("+91", "")
                            ?.length === 10 ||
                          props.formData.callId
                        ) {
                          props.navigate("/linkComplaint");
                        }
                      }}
                      data-cy="link-complaint"
                      className="font-color-primary padding-left-small"
                    >
                      Link
                    </span>
                  </div>
                  <div className="flex-center-children-vertically margin-top-default margin-bottom-default">
                    <hr
                      style={{ width: "100%" }}
                      className="display-inline-block border-color-secondary-lite border-top-left-right-none flex-basis-1 "
                    />
                    <span className=" margin-horizontal-default display-inline-block font-color-secondary font-size-small">
                      OR
                    </span>
                    <hr
                      style={{ width: "100%" }}
                      className="display-inline-block border-color-secondary-lite border-top-left-right-none flex-basis-1 "
                    />
                  </div>

                  <Button
                    text="Create"
                    data-cy="create-button"
                    type="submit"
                    boxShadow={false}
                    loading={props.complaints?.raiseComplaintsLoading}
                    disabled={isDisabled}
                  />
                </div>
              </form>
            ) : (
              <div
                className="inherit-parent-height padding-horizontal-large display-flex flex-direction-column flex-justify-content-center flex-align-items-center"
                data-cy="notInLocation-fallBack"
              >
                <NotInLocationPicture />
                <div className="padding-top-larger font-family-RHD-medium font-size-default">
                  Not in location !
                </div>
                <div className="padding-top-medium text-align-center font-size-medium">
                  Reach the assigned location to continue.
                </div>
              </div>
            )
          ) : (
            <div>
              <Suspense />
            </div>
          )}
        </div>
      </div>
      <Modal
        show={isValidArray(file?.image)}
        canIgnore={true}
        onClose={() => {
          setFile({ ...file, image: [] });
        }}
        width="inherit-parent-width"
        maxWidth="max-width-800px"
        background="false"
        boxShadow="false"
        borderRadius="false"
        height="inherit-parent-height max-height-500px"
      >
        <div
          data-cy="cropper-modal"
          className={`background-white inherit-parent-height border-radius-default box-shadow-default font-family-gilroy-regular font-color-secondary`}
        >
          <CropperModal
            className="border-radius-default"
            OnBlobCreate={(blob) => {
              const imageFile = new File([blob], `${+new Date()}.png`, {
                type: "image/png"
              });
              setCroppedImage([...croppedImage, imageFile]);
            }}
            file={file.image}
            setFile={() => {
              setFile({ ...file, image: [] });
            }}
          />
        </div>
      </Modal>
    </div>
  );
}

const mapStateToProps = function (state) {
  return {
    complaints: state.complaints,
    locations: state.locations,
    calls: state.calls,
    profile: state.profile
  };
};

const mapDispatchToProps = function () {
  return {
    createComplaint: (data, navigate, ieAccess) =>
      createComplaint(data, navigate, ieAccess)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IeRaiseComplaint);

const Suspense = (props) => {
  return [...Array(5)].map((_data, index) => (
    <div className="padding-default" key={index}>
      <div className="shimmer padding-larger border-radius-default  inherit-parent-width" />
    </div>
  ));
};
